import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, ArrowRight } from 'lucide-react';
import { mockCompanyInfo } from '../mock';

const ContactUs = () => {
  return (
    <div className="bg-[#FAFAFA]">
      {/* Hero with image */}
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1767150145058-367fb68021f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBza3lsaW5lJTIwY2l0eXNjYXBlJTIwYnVzaW5lc3N8ZW58MHx8fHwxNzc0NTI0OTY0fDA&ixlib=rb-4.1.0&q=85" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-br from-slate-900/95 to-teal-900/70" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 text-center py-28">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-teal-300 mb-4 block">Get in Touch</span>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'var(--font-heading)' }}>Contact Us</h1>
          <p className="text-lg text-slate-300 max-w-xl mx-auto">Have questions? Our team is here to help. Reach out by phone or email.</p>
        </div>
      </section>

      {/* Contact Methods */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
            <a href={`tel:${mockCompanyInfo.phone}`} data-testid="contact-phone" className="bento-card bg-white p-8 text-center group cursor-pointer">
              <div className="w-14 h-14 rounded-2xl bg-teal-50 flex items-center justify-center mx-auto mb-5 group-hover:bg-teal-100 transition-colors">
                <Phone className="h-6 w-6 text-[#115E59]" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>Call Us</h3>
              <p className="text-sm text-[#115E59] font-semibold">{mockCompanyInfo.phone}</p>
              <p className="text-xs text-slate-500 mt-2">Monday to Friday, 9am to 5pm ET</p>
            </a>
            <a href={`mailto:${mockCompanyInfo.email}`} data-testid="contact-email" className="bento-card bg-white p-8 text-center group cursor-pointer">
              <div className="w-14 h-14 rounded-2xl bg-teal-50 flex items-center justify-center mx-auto mb-5 group-hover:bg-teal-100 transition-colors">
                <Mail className="h-6 w-6 text-[#115E59]" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>Email Us</h3>
              <p className="text-sm text-[#115E59] font-semibold">{mockCompanyInfo.email}</p>
              <p className="text-xs text-slate-500 mt-2">We respond within one business day</p>
            </a>
          </div>

          {/* Quick Actions with images */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-24">
            <Link to="/apply" className="group relative rounded-2xl overflow-hidden min-h-[200px] flex items-end">
              <div className="absolute inset-0">
                <img src="https://images.pexels.com/photos/7256463/pexels-photo-7256463.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/70 to-slate-950/30" />
              </div>
              <div className="relative z-10 p-8">
                <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'var(--font-heading)' }}>Looking for Financing?</h3>
                <p className="text-sm text-slate-300 mb-4">Start your loan application today and get a response within 24 hours.</p>
                <span className="inline-flex items-center gap-2 text-sm font-semibold text-teal-300 group-hover:text-teal-200 transition-colors">
                  Apply Now <ArrowRight className="h-4 w-4" />
                </span>
              </div>
            </Link>
            <Link to="/partner" className="group relative rounded-2xl overflow-hidden min-h-[200px] flex items-end">
              <div className="absolute inset-0">
                <img src="https://images.pexels.com/photos/4175028/pexels-photo-4175028.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/70 to-slate-950/30" />
              </div>
              <div className="relative z-10 p-8">
                <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'var(--font-heading)' }}>Want to Partner With Us?</h3>
                <p className="text-sm text-slate-300 mb-4">Join our referral program and earn commissions on funded deals.</p>
                <span className="inline-flex items-center gap-2 text-sm font-semibold text-teal-300 group-hover:text-teal-200 transition-colors">
                  Become a Partner <ArrowRight className="h-4 w-4" />
                </span>
              </div>
            </Link>
          </div>

          {/* Offices */}
          <div>
            <div className="text-center mb-12">
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#115E59] mb-4 block">Our Offices</span>
              <h2 className="text-3xl font-bold text-slate-900" style={{ fontFamily: 'var(--font-heading)' }}>Global Locations</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white border border-slate-200 rounded-xl p-6">
                <h3 className="text-sm font-bold text-slate-900 mb-2">Miami HQ</h3>
                <p className="text-xs text-slate-500 leading-relaxed">{mockCompanyInfo.address.street}<br />{mockCompanyInfo.address.suite}<br />{mockCompanyInfo.address.city}, {mockCompanyInfo.address.state} {mockCompanyInfo.address.zip}</p>
              </div>
              {mockCompanyInfo.additionalLocations.map((loc) => (
                <div key={loc.name} className="bg-white border border-slate-200 rounded-xl p-6">
                  <h3 className="text-sm font-bold text-slate-900 mb-2">{loc.name}</h3>
                  <p className="text-xs text-slate-500 leading-relaxed whitespace-pre-line">{loc.address}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
